export default __webpack_public_path__ + "static/media/saxophone.167405df.jpg";